export default __webpack_public_path__ + "static/media/Close.1b904b7d.svg";